import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { intakeBudgetStepSchema } from '../IntakeBudgetStep/IntakeBudgetStep.schema';
import {
  intakeRequestDescriptionStepFormDataDefault,
  intakeRequestDescriptionStepFormDataSchema,
} from '../IntakeRequestDescriptionStep/IntakeRequestDescriptionStep.schema';
import {
  intakeRequestDetailsStepFormDataDefault,
  intakeRequestDetailsStepFormDataSchema,
} from '../IntakeRequestDetailsStep/IntakeRequestDetailsStep.schema';

export const intakeRequestComplexStepFormDataSchema = z.object({
  ...intakeRequestDetailsStepFormDataSchema.shape,
  summary: intakeRequestDescriptionStepFormDataSchema,
  ...intakeBudgetStepSchema.shape,
});

export type IntakeRequestComplexStepFormData = z.infer<typeof intakeRequestComplexStepFormDataSchema>;

export const intakeRequestComplexStepFormDataDefault: DefaultValues<IntakeRequestComplexStepFormData> = {
  ...intakeRequestDetailsStepFormDataDefault,
  summary: {
    ...intakeRequestDescriptionStepFormDataDefault,
  },
};
